export default {
  submitText: '提交',
  emptyBtn: false,
  group: [
    {
      label: '租户信息',
      prop: 'group1',
      column: [
        {
          label: 'id',
          prop: 'id',
          display: false,
        },

        {
          label: '租户名称',
          prop: 'name',
          disabled: true,
          rules: [
            {
              required: true,
              message: '请输入租户名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '联系电话',
          prop: 'mobile',
          disabled: true,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              required: true,
              message: '请输入手机号',
              trigger: 'blur',
            },
            {
              trigger: 'blur',
              min: 11,
              max: 11,
              message: '请输入11位手机号码',
            },
          ],
        },
        {
          label: '性别',
          prop: 'sex',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=sex',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请选择性别',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '身份证',
          prop: 'idCard',
          disabled: true,
          maxlength: 20,
          rules: [
            {
              required: true,
              message: '请输入身份证',
              trigger: 'blur',
            },
          ],
        },

        {
          label: '工作单位',
          width: 150,
          prop: 'companyName',
          type: 'tree',
          disabled: true,
          dicUrl: 'api/v4ward/departmentCompany/getDepartmentCompanyList',
          props: { label: 'companyName', value: 'id' },
          rules: [
            {
              required: true,
              message: '请选择工作单位',
              trigger: 'blur',
            },
          ],
        },

      ],
    },
    {
      label: '租赁信息（修改租赁信息后请核对该租户的本月账单信息是否正确）',
      prop: 'group2',
      column: [
        {
          label: 'rentRecordId',
          prop: 'rentRecordId',
          display: false,
        },
        {
          label: '租户类型',
          prop: 'departmentRentType',
          type: 'select',
          tip: '提示：修改租户类型后可能对本月账单产生影响。',
          tipPlacement: 'top-start',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=department_rent_type',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请选择租户类型',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '减免金额',
          maxlength: 12,
          prop: 'derateMoney',
          tip: '提示：修改减免金额后可能对本月账单产生影响。',
          tipPlacement: 'top-start',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '押金金额',
          maxlength: 12,
          prop: 'deposit',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '押金编号',
          maxlength: 30,
          prop: 'depositNo',
          showWordLimit: true,
          overHidden: true,
          rules: [
            {pattern: /^[0-9a-zA-Z]*$/, message: '只允许填写字母或者数字组合'},
          ],
        },
        {
          label: '电费起码',
          maxlength: 12,
          prop: 'electricityBeginNum',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
            {
              required: true,
              message: '请输入电费起码',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '水费起码',
          maxlength: 12,
          prop: 'waterBeginNumber',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
        {
          label: '划扣账户',
          prop: 'bankCardNo',
          maxlength: 20,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              message: '请输入银行卡号码',
              trigger: 'blur',
            },
            {
              min: 16,
              max: 19,
              message: '请输入最少16位最多19位号码',
            },
          ],
        },
        {
          label: '划扣银行',
          prop: 'bank',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=bill_cutBank',
          props: { label: 'dictValue', value: 'dictKey' },
        },
      ],
    },
  ],
};
